import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { Usuario, Perfil, Token } from './models/usuario';
import { GridObject } from 'src/app/structure/model/grid-view';
import { ResponseApi } from 'src/app/structure/model/response-api';
import { ApiService } from 'src/app/structure/service/api.service';

import { ConfigsLoaderService } from 'src/app/services/configs-loader.service';

const httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'},)};


@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  private readonly ApiUrl = `${environment.ApiUrl}Usuario`;

  constructor(
        private httpClient: HttpClient,
        private api: ApiService,
        private configsLoaderService: ConfigsLoaderService
    ) { }

    getListPaged(obj: GridObject): Observable<ResponseApi> {
      return this.api.post(`Usuario/ListPaged`,obj)
          .pipe((res: any) => res,
              catchError(error => throwError(error)));
    }

    getItem(id: number): Observable<Usuario> {
      return this.api.get(`Usuario/GetById?id=${id}`)
        .pipe(map(res => <Usuario>res.data),
          catchError(error => throwError(error)));
    }

    getByCpf(cpf: string): Observable<Usuario> {
      return this.api.get(`Usuario/GetByCpf?cpf=${cpf}`)
        .pipe(map(res => <Usuario>res.data),
          catchError(error => throwError(error)));
    }

    getListFilter(filtro: string): Observable<Usuario[]> {
      const filter = filtro.length > 0 ? `?nome=${filtro}&` : '?';
      return this.httpClient.get<Usuario[]>(`${this.configsLoaderService.ApiUrl}${filter}`);
    }

    onDelete(id: number): Observable<number> {
      return this.api.delete(`Usuario/${id}`)
      .pipe((res) => res,
        catchError(error => throwError(error)));
    }

    /*onSave(Usuario: Usuario): Observable<Usuario> {
        return this.api.post(`Usuario/Add`, Usuario)
        .pipe((res) => res,
          catchError(error => throwError(error)));
    }*/

    onGerarToken(Token: Token): Observable<Token> {
      return this.api.post(`Token/Add`, Token)
      .pipe((res) => res,
        catchError(error => throwError(error)));
  }

    async onUpdate(usuario: Usuario): Promise<any>  {
      return await this.api.asyncPut(`Usuario/Update`, usuario)
    }

    getComboPerfil(): Observable<Perfil[]> {
      return this.api.get(`Perfil/List`)
        .pipe(map(res => <Perfil[]>res.data),
          catchError(error => throwError(error)));
    }

    onGetAcessoPagina(idusuario: number, idpagina: number):any {
      return this.api.get(`Usuario/GetAcessoPagina?idusuario=${idusuario}&idpagina=${idpagina}`);
    }

     onGetAcessoRelatorio(idusuario: number, idmodulorelatorio: number): any {
      return this.api.get(`Usuario/GetAcessoRelatorio?idusuario=${idusuario}&idmodulorelatorio=${idmodulorelatorio}`);
    }

    async onAsyncEnviarTokenParaEmail(usuario: any): Promise<any> {
      return await this.api.asyncPost(`Usuario/enviarTokenParaEmail/`, usuario);
    }

    async onPostRedefinirSenha(usuario: any): Promise<any> {
      return await this.api.asyncPost(`Usuario/redefinirSenha`, usuario);
    }


    async onPostAddUsuarioAPILoginUnico(usuario: Usuario): Promise<Usuario> {
        return await this.api.asyncPost(`Usuario/AddUsuarioAPILoginUnico`, usuario);
    }

    async onPutUpdateUsuarioAPILoginUnico(usuario: Usuario): Promise<Usuario> {
      return await this.api.asyncPut(`Usuario/UpdateUsuarioAPILoginUnico`, usuario);
    }

    async onGetByCpfApiLogin(cpf: string): Promise<Usuario> {
      return await this.api.asyncGet(`Usuario/GetByCpfApiLogin?cpf=${cpf}`);
    }

    async onGetTokenEmailValido(cpf: string, token: string, datetime: string):  Promise<any> {
      return await this.api.asyncGet(`Usuario/TokenEmailValido?cpf=${cpf}&token=${token}&datetime=${datetime}`);
    }

}
